<template>
  <div class="box">
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showVideoModal: false,
      video_url: null
    }
  },
  methods: {
    playVideo(e) {
      this.video_url = e.currentTarget.getAttribute("vimeo_url")
      this.set_video_embed(this.video_url, e.currentTarget)
    },
    set_video_embed(vimeo_url, element) {
      this.$store.dispatch('getVideoEmbed', vimeo_url)
        .then(function(response) {
          //console.log(response)
          if(response.vimeoVideo) {
            // create iframe
            let container = document.createElement("div")
            container.innerHTML = response.vimeoVideo.embed.html
            let iframe = container.querySelector("iframe")
            iframe.width = 640
            iframe.height = 360
            iframe.hidden = true
            iframe.src = iframe.src + "&autoplay=true&transparent=false&responsive=true"
            iframe.onload = function() {
              // when loaded show iframe and hide image
              this.parentNode.querySelector("img").style.display = "none"
              //this.parentNode.querySelector("figcaption").style.display = "none"
              this.hidden = false
            }
            // append iframe
            element.classList.add("playing")
            element.appendChild(iframe)
          }
        })
    }
  },
  mounted: function(){
    let elements = window.document.querySelectorAll("figure.attachment.attachment--preview")
    Array.from(elements).forEach( (el) => {
      let trix_attributes = el.getAttribute("data-trix-attachment")
      if(trix_attributes.includes("vimeo-embed")){
        // add clearfix
        let clearfix = document.createElement("div")
        clearfix.classList.add("clearfix")
        el.parentNode.insertBefore(clearfix, el)

        // update element class
        el.classList.add("vimeo-preview-image")

        // get attribute values
        let video_url_param = trix_attributes.match(/"video_url":"([^"]*)/)
        let thumbnail_url_param = trix_attributes.match(/"thumbnail_url":"([^"]*)/)

        // get vimeo id
        el.setAttribute("vimeo_url", video_url_param[1])
        el.setAttribute("src", thumbnail_url_param[1])
        el.querySelector("img").setAttribute("src", thumbnail_url_param[1])

        el.addEventListener("click", this.playVideo);
      }
    })
  },
  components: {
    //VideoModal: () => import(/* webpackChunkName: "video-modal" */ '@/components/elements/VideoModal.vue')
  }
}
</script>
<style scoped lang="scss">
 @import "../../assets/scss/variables";

.box {
  border-left: 12px solid $dark;
  background-color: $off-white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  color: $dark;
  font-size: 1.125rem;
  line-height: 1.88;
  padding: 0;
  width: 100%;

  h2, h3 {
    color: $dark;
  }

  .content {
    padding: 4rem;
    height: 100%;
    width: 100%;
    display: table;
  }

  button{
    //position: absolute;
    //margin-top:15px;
  }
}

</style>
